import { LOCATION_CHANGE, push } from 'redux-first-history'

const FIRESTORE_SCHEMA_VERSION = 2

const CHANGING_PASSWORD = 'auth/CHANGING_PASSWORD'
const CHANGING_PASSWORD_ERROR = 'auth/CHANGING_PASSWORD_ERROR'
const CHANGING_PASSWORD_SUCCESS = 'auth/CHANGING_PASSWORD_SUCCESS'
const CLEAR_MESSAGES = 'auth/CLEAR_MESSAGES'
const CONFIRM_FORGOT_PASSWORD = 'auth/CONFIRM_FORGOT_PASSWORD'
const CONFIRM_FORGOT_PASSWORD_ERROR = 'auth/CONFIRM_FORGOT_PASSWORD_ERROR'
const CONFIRM_FORGOT_PASSWORD_SUCCESS = 'auth/CONFIRM_FORGOT_PASSWORD_SUCCESS'
const FORGOT_PASSWORD = 'auth/FORGOT_PASSWORD'
const FORGOT_PASSWORD_ERROR = 'auth/FORGOT_PASSWORD_ERROR'
const FORGOT_PASSWORD_SUCCESS = 'auth/FORGOT_PASSWORD_SUCCESS'
const INIT_FIRESTORE_USER = 'auth/INIT_FIRESTORE_USER'
const SET_ERROR = 'auth/SET_ERROR'
const SIGNING_IN = 'auth/SIGNING_IN'
const SIGNING_IN_ERROR = 'auth/SIGNING_IN_ERROR'
const SIGNING_IN_SUCCESS = 'auth/SIGNING_IN_SUCCESS'
const SIGNING_OUT = 'auth/SIGNING_OUT'
const SIGNING_OUT_ERROR = 'auth/SIGNING_OUT_ERROR'
const SIGNING_OUT_SUCCESS = 'auth/SIGNING_OUT_SUCCESS'
const SIGNING_UP = 'auth/SIGNING_UP'
const SIGNING_UP_ERROR = 'auth/SIGNING_UP_ERROR'
const SIGNING_UP_SUCCESS = 'auth/SIGNING_UP_SUCCESS'
const UPDATING_PROFILE = 'auth/UPDATING_PROFILE'
const UPDATING_PROFILE_ERROR = 'auth/UPDATING_PROFILE_ERROR'
const UPDATING_PROFILE_SUCCESS = 'auth/UPDATING_PROFILE_SUCCESS'

const initialState = {
  error: '',
  isLoading: false,
  success: '',
}

export default (state = initialState, action) => {
  const { type, ...actionProps } = action
  switch (action.type) {
    case CHANGING_PASSWORD:
    case CONFIRM_FORGOT_PASSWORD:
    case FORGOT_PASSWORD:
    case SIGNING_IN:
    case SIGNING_UP:
    case SIGNING_OUT:
      return {
        ...state,
        error: '',
        isLoading: true,
        success: '',
      }
    case CHANGING_PASSWORD_ERROR:
    case CONFIRM_FORGOT_PASSWORD_ERROR:
    case FORGOT_PASSWORD_ERROR:
    case SIGNING_IN_ERROR:
    case SIGNING_UP_ERROR:
    case SIGNING_OUT_ERROR:
      return {
        ...state,
        ...actionProps,
        isLoading: false,
      }
    case CHANGING_PASSWORD_SUCCESS:
    case CONFIRM_FORGOT_PASSWORD_SUCCESS:
    case FORGOT_PASSWORD_SUCCESS:
    case SIGNING_IN_SUCCESS:
    case SIGNING_UP_SUCCESS:
    case SIGNING_OUT_SUCCESS:
      return {
        ...state,
        ...actionProps,
        isLoading: false,
      }
    case CLEAR_MESSAGES:
    case LOCATION_CHANGE:
      return {
        ...state,
        error: '',
        success: '',
      }
    case SET_ERROR:
      return {
        ...state,
        error: action.error,
      }
    default:
      return state
  }
}

export const changePassword =
  (oldPassword, newPassword) => async (dispatch, getState, getFirebase) => {
    dispatch({ type: CHANGING_PASSWORD })
    try {
      await getFirebase()
        .auth()
        .signInWithEmailAndPassword(
          getFirebase().auth().currentUser.email,
          oldPassword
        )
      await getFirebase().auth().currentUser.updatePassword(newPassword)
      dispatch({
        success: 'Your password has been changed.',
        type: CHANGING_PASSWORD_SUCCESS,
      })
    } catch (err) {
      dispatch(handleError({ err, type: CHANGING_PASSWORD_ERROR }))
    }
  }

export const clearMessages = () => ({ type: CLEAR_MESSAGES })

export const confirmForgotPassword =
  (code, newPassword) => async (dispatch, getState, getFirebase) => {
    dispatch({ type: CONFIRM_FORGOT_PASSWORD })
    try {
      await getFirebase().auth().confirmPasswordReset(code, newPassword)
      dispatch({
        success: 'Your password has been changed.',
        type: CONFIRM_FORGOT_PASSWORD_SUCCESS,
      })
    } catch (err) {
      dispatch(handleError({ err, type: CONFIRM_FORGOT_PASSWORD_ERROR }))
    }
  }

export const forgotPassword = (email) => (dispatch, getState, getFirebase) => {
  dispatch({ type: FORGOT_PASSWORD })
  return getFirebase()
    .auth()
    .sendPasswordResetEmail(email)
    .then(() => {
      dispatch({
        success: 'Password reset request has been emailed to ' + email,
        type: FORGOT_PASSWORD_SUCCESS,
      })
    })
    .catch((err) => dispatch(handleError({ err, type: FORGOT_PASSWORD_ERROR })))
}

const handleError =
  ({ err, type, ...other }) =>
  (dispatch) => {
    console.log({ err, type, ...other })
    const error = (err.message || err).replace('Firebase: ', '')
    dispatch({ ...other, error, type })
  }

export const initFirestoreUser =
  (user) => async (dispatch, getState, getFirebase) => {
    dispatch({ type: INIT_FIRESTORE_USER })

    await getFirebase().firestore().collection('users').doc(user.uid).set(
      {
        priceSources: getState().settings.priceSources,
        version: FIRESTORE_SCHEMA_VERSION,
      },
      { merge: true }
    )
  }

export const setError = (error) => ({ error, type: SET_ERROR })

export const signIn =
  ({ email, password }) =>
  async (dispatch, getState, getFirebase) => {
    dispatch({ type: SIGNING_IN })
    try {
      const userCredential = await getFirebase()
        .auth()
        .signInWithEmailAndPassword(email, password)
      const doc = await getFirebase()
        .firestore()
        .collection('users')
        .doc(userCredential.user.uid)
        .get()
      if (!doc.exists || doc.data().version !== FIRESTORE_SCHEMA_VERSION) {
        dispatch(await initFirestoreUser(userCredential.user))
      }
      dispatch({ type: SIGNING_IN_SUCCESS })
      dispatch(push('/'))
      window.location.reload(false)
    } catch (err) {
      dispatch(handleError({ err, type: SIGNING_IN_ERROR }))
    }
  }

export const signOut = () => async (dispatch, getState, getFirebase) => {
  dispatch({ type: SIGNING_OUT })
  try {
    dispatch(push('/'))
    await getFirebase().auth().signOut()
    dispatch({ type: SIGNING_OUT_SUCCESS })
  } catch (err) {
    dispatch(handleError({ err, type: SIGNING_OUT_ERROR }))
  }
}

export const signUp =
  ({ email, password, username }) =>
  async (dispatch, getState, getFirebase) => {
    dispatch({ type: SIGNING_UP })
    try {
      const res = await fetch(
        'https://us-central1-edhrec-1563844611919.cloudfunctions.net/app/register',
        {
          body: JSON.stringify({ email, password, username }),
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
        }
      )
      const data = await res.json()

      if (data.error) {
        dispatch(handleError({ err: data.error, type: SIGNING_UP_ERROR }))
      } else {
        dispatch({ type: SIGNING_UP_SUCCESS })
        dispatch(push('/'))
        dispatch(await signIn({ email, password }))
      }
    } catch (err) {
      dispatch(handleError({ err, type: SIGNING_UP_ERROR }))
    }
  }

export const updateProfile =
  (newProfile) => async (dispatch, getState, getFirebase) => {
    const { uid } = getState().firebase.auth
    dispatch({ newProfile, type: UPDATING_PROFILE })
    try {
      await getFirebase()
        .firestore()
        .collection('users')
        .doc(uid)
        .set(newProfile, { merge: true })
      dispatch({ type: UPDATING_PROFILE_SUCCESS })
    } catch (err) {
      dispatch(handleError({ err, type: UPDATING_PROFILE_ERROR }))
    }
  }
